import { APP_ID, environment } from '@env';
import th from './th';
import en from './en';

declare let window: any;

export function LocaleLoader(locale?: 'th' | 'en') {
  return new Promise<any>((resolve, reject) => {
    if (!locale) {
      locale = window.localStorage.getItem(`${APP_ID}-${environment.APP_ENV}-locale`) || 'th';
    }
    if (locale === 'th') {
      resolve(th);
    } else {
      resolve(en);
    }
  });
}
